module.exports = __webpack_public_path__ + "static/media/mac_excite.d61d828a.webp";